import React, { useEffect, useState } from 'react'
import { Form, Formik, useFormikContext } from 'formik'

import { Button } from '@components/Buttons'
import { PrimaryTypeEnum } from '@interfaces/PrimaryTypeEnum'
import { OrderedKeyEnum } from '@interfaces/OrderedEnum'
import { SortEnum } from '@interfaces/SortEnum'
import { OptionFormProps } from './CategoryList/interface'
import FormSection from './FormSection'

interface TriggerRecommendationSearchChangeProps {
  recommendationSearch: PrimaryTypeEnum
}

function TriggerRecommendationSearchChange({
  recommendationSearch,
}: TriggerRecommendationSearchChangeProps) {
  const { resetForm } = useFormikContext<OptionFormProps>()
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    setFirstRender(false)

    if (!firstRender) {
      resetForm({
        values: {
          ordered: [PrimaryTypeEnum.NEW, PrimaryTypeEnum.ENDED].includes(
            recommendationSearch
          )
            ? `${OrderedKeyEnum.UPDATED_AT}:${SortEnum.DESC}`
            : recommendationSearch === PrimaryTypeEnum.TOP_CHART
            ? `${OrderedKeyEnum.PURCHASED}:${SortEnum.DESC}`
            : `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          recommendTypeSearch: undefined,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendationSearch])

  return null
}

export default function OptionForm({
  handleSearch,
  initialValues,
  ...props
}: {
  initialValues: OptionFormProps
  handleSearch(form: OptionFormProps): Promise<void>
  isEbook: boolean
  recommendationSearch: PrimaryTypeEnum
}) {
  return (
    <Formik initialValues={initialValues} onSubmit={handleSearch}>
      {({ resetForm, isSubmitting }) => (
        <Form>
          <div className='flex desktop-tablet:space-x-[20px] items-center border-b-[1px] border-gray-3 dark:border-purple mb-[19.5px] pb-[19.5px] mobile:grid mobile:items-start mobile:gap-y-[20px]'>
            <FormSection {...props} />
            <TriggerRecommendationSearchChange
              recommendationSearch={props.recommendationSearch}
            />
            <div className='flex mobile:ml-auto'>
              <Button
                type='button'
                className='text-secondary dark:text-dark-10 underline font-medium'
                onClick={() => {
                  const initValues = {
                    ordered: [
                      PrimaryTypeEnum.NEW,
                      PrimaryTypeEnum.ENDED,
                    ].includes(props.recommendationSearch)
                      ? `${OrderedKeyEnum.UPDATED_AT}:${SortEnum.DESC}`
                      : props.recommendationSearch === PrimaryTypeEnum.TOP_CHART
                      ? `${OrderedKeyEnum.PURCHASED}:${SortEnum.DESC}`
                      : `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
                    recommendTypeSearch: undefined,
                  }
                  resetForm({ values: initValues })
                  handleSearch(initValues)
                }}
              >
                <span className='text-[14px]'>ล้างค่า</span>
              </Button>
              <Button
                type='submit'
                disabled={isSubmitting}
                className='bg-primary dark:bg-purple text-white dark:text-white-2'
              >
                <span className='text-[14px]'>ค้นหา</span>
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
